function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreVertical(_ref, svgRef) {
  var _ref2, _ref3, _ref4;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Menu / More_Vertical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.91699 14.9993C9.91699 15.4596 10.2901 15.8327 10.7503 15.8327C11.2106 15.8327 11.5837 15.4596 11.5837 14.9993C11.5837 14.5391 11.2106 14.166 10.7503 14.166C10.2901 14.166 9.91699 14.5391 9.91699 14.9993Z",
    stroke: "#394DFC",
    style: (_ref2 = {
      stroke: "#394DFC"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.2235 0.3020 0.9882)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91699 9.99935C9.91699 10.4596 10.2901 10.8327 10.7503 10.8327C11.2106 10.8327 11.5837 10.4596 11.5837 9.99935C11.5837 9.53911 11.2106 9.16602 10.7503 9.16602C10.2901 9.16602 9.91699 9.53911 9.91699 9.99935Z",
    stroke: "#394DFC",
    style: (_ref3 = {
      stroke: "#394DFC"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.2235 0.3020 0.9882)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91699 4.99935C9.91699 5.45959 10.2901 5.83268 10.7503 5.83268C11.2106 5.83268 11.5837 5.45959 11.5837 4.99935C11.5837 4.53911 11.2106 4.16602 10.7503 4.16602C10.2901 4.16602 9.91699 4.53911 9.91699 4.99935Z",
    stroke: "#394DFC",
    style: (_ref4 = {
      stroke: "#394DFC"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.2235 0.3020 0.9882)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertical);
export default __webpack_public_path__ + "static/media/more_vertical.b13e1b133e50f60fc76e34c7c2d443b3.svg";
export { ForwardRef as ReactComponent };